import { connect } from "react-redux";
// Component
import SelectSurveyModal from "components/CreateSurvey/BaseInfo/SelectSurveyModal";
// Action
import {
  openConfirmDialog,
  closeConfirmDialog
} from "redux/modules/confirmDialog";
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  setSelectSurveyErrors,
  applySurveyDetail,
  closeSelectSurveyModal
} from "redux/modules/createSurvey";
import api from "api";

const mapStateToProps = state => ({
  selectSurveyModal: state.createSurvey.selectSurveyModal,
  surveys: state.createSurvey.surveys
});

const mapDispatchToProps = dispatch => ({
  // 閉じる
  handleClose: () => dispatch(closeSelectSurveyModal()),
  applySurveyDetail: id => {
    const errors = [];
    if (id === "") {
      errors.push("設定を利用するアンケートを選択してください。");
    }
    dispatch(setSelectSurveyErrors(errors));
    if (errors.length > 0) {
      return;
    }

    const dialogData = {
      title: "確認",
      contentText:
        "選択したアンケートの設定を適用します。編集中の内容は失われますがよろしいですか？",
      btnLabel: "実行",
      handleClick: () => {
        api
          .get(`survey_detail/${id}`)
          .then(res => {
            dispatch(applySurveyDetail(res));
            dispatch(closeConfirmDialog());
            dispatch(closeSelectSurveyModal());
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };
    dispatch(openConfirmDialog(dialogData));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectSurveyModal);



// WEBPACK FOOTER //
// ./src/containers/CreateSurvey/BaseInfo/SelectSurveyContainer.js